<nav class="">
  <!-- main bar -->
  <div class="nav">
    <div class="nav-items">
      <ng-container [ngTemplateOutlet]="$safeNavigationMigration(navConfig?.sideNavTemplate)"></ng-container>
    </div>

    <div class="nav-bottom">
      <rcp-nav-list-container type="primary">
        <rcp-nav-list-group>
          @if (isLoggedIn && navConfig?.showLogoutInSideNav) {
            <rcp-nav-list-item
              label="Tweestapsverificatie"
              [iconTyped]="faKey"
              routerLink="/app/otp/"
              routerLinkActive="active"
            />
            <rcp-nav-list-item
              (click)="clickLogout($event)"
              label="Uitloggen"
              [iconTyped]="faPowerOff"
            ></rcp-nav-list-item>
          }
          <rcp-nav-list-item
            label="{{ 'qz-collapse-zm' | translate }}"
            (click)="clickMenu()"
            popoverText="{{ 'qz-menu-zm' | translate }}"
            [iconTyped]="isExpanded ? falLeftToLine : falRightToLine"
          />
        </rcp-nav-list-group>
      </rcp-nav-list-container>
    </div>
  </div>
</nav>
